import React, { PureComponent } from "react";
import "./EstReach.scss";
import PieChart from "./PieChart";
import BarChart from "./BarChart";
import TimeSeries from "./TimeSeries";
import { downloadCSVData, downloadCanvasWithTitle } from "../utils";
import { connect } from "react-redux";
import moment from "moment-timezone";
import NoData from "../NoData/NoData";
import IntervalSelector from "../IntervalSelector";
import { Icon } from "semantic-ui-react";
import CustomDropdown from "../ChartsOptionsSidebar/CustomDropdown";
import html2canvas from "html2canvas";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import DownloadChart from "../DownloadChart";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";

import { ReactComponent as ComparisionIcon } from "../../../../../assets/svg/CompareChartIcon.svg";
class EstReach extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isTotal: true,
        };
        this.chartEl = React.createRef();
    }

    handleIntervalChange = (val) => {
        this.props.handleIntervalChange(val);
    };

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        html2canvas(this.chartEl.current, { backgroundColor: options.background ? "#fff" : null, allowTaint: true, useCORS: true }).then((canvas) => {
            cb && cb();
            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    getPlatformName(id) {
        return this.props.allPlatforms.find((plt) => plt.id === id).name;
    }

    handleChangeSplineChartType(val) {
        this.setState({
            ...this.state,
            splineType: val,
        });
    }

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let formatString = "YYYY-MM-DD HH:mm";
        let csvFmt = [["Type", "Platform"].concat(this.props.data.timeseries.xs.map((d) => (d === "x" ? "x" : moment(d).tz(tz).format(formatString))))];

        if (this.props.comparisionData) {
            csvFmt = [
                ...csvFmt,
                ...[
                    ["Comparison Type", "Comparison Platform"].concat(
                        this.props.comparisionData.timeseries.xs.map((d) => (d === "x" ? "x" : moment(d).tz(tz).format(formatString))),
                    ),
                ],
            ];
        }

        //  csvFmt = [["Type", "Platform"].concat(this.props.data.timeseries.xs.map((d) => (d === "x" ? "x" : moment(d).tz(tz).format(formatString))))];
        for (let platform in this.props.data.timeseries.totres) {
            if (
                platform == "6ce32c0a-a789-11e4-a34f-74867a1157ba" ||
                platform == "6ce338bd-a789-11e4-a34f-74867a1157ba" ||
                platform == "6ce32a97-a789-11e4-a34f-74867a1157ba" ||
                platform == "1cbacd32-a97d-11ea-89d1-02f9d9f14362"
            ) {
                platform !== "ALL" && csvFmt.push(["Total Estimate", this.getPlatformName(platform)].concat(this.props.data.timeseries.totres[platform]));
            }
        }

        if (this.props.comparisionData) {
            for (let platform in this.props.comparisionData.timeseries.totres) {
                if (
                    platform == "6ce32c0a-a789-11e4-a34f-74867a1157ba" ||
                    platform == "6ce338bd-a789-11e4-a34f-74867a1157ba" ||
                    platform == "6ce32a97-a789-11e4-a34f-74867a1157ba" ||
                    platform == "1cbacd32-a97d-11ea-89d1-02f9d9f14362"
                ) {
                    platform !== "ALL" &&
                        csvFmt.push(
                            ["Comparison Total Estimate", this.getPlatformName(platform)].concat(this.props.comparisionData.timeseries.totres[platform]),
                        );
                }
            }
        }

        for (let platform in this.props.data.timeseries.avgres) {
            if (
                platform == "6ce32c0a-a789-11e4-a34f-74867a1157ba" ||
                platform == "6ce338bd-a789-11e4-a34f-74867a1157ba" ||
                platform == "6ce32a97-a789-11e4-a34f-74867a1157ba" ||
                platform == "1cbacd32-a97d-11ea-89d1-02f9d9f14362"
            ) {
                platform !== "ALL" && csvFmt.push(["Average Estimate", this.getPlatformName(platform)].concat(this.props.data.timeseries.avgres[platform]));
            }
        }

        if (this.props.comparisionData) {
            for (let platform in this.props.comparisionData.timeseries.avgres) {
                if (
                    platform == "6ce32c0a-a789-11e4-a34f-74867a1157ba" ||
                    platform == "6ce338bd-a789-11e4-a34f-74867a1157ba" ||
                    platform == "6ce32a97-a789-11e4-a34f-74867a1157ba" ||
                    platform == "1cbacd32-a97d-11ea-89d1-02f9d9f14362"
                ) {
                    platform !== "ALL" &&
                        csvFmt.push(
                            ["Comparison Average Estimate", this.getPlatformName(platform)].concat(this.props.comparisionData.timeseries.avgres[platform]),
                        );
                }
            }
        }

        let firstIndLen = csvFmt[0].length;
        let lastIndLen = csvFmt[csvFmt.length - 1].length;

        let length;
        if (firstIndLen > lastIndLen) length = firstIndLen;
        else length = lastIndLen;

        let arr = [];
        for (let i = 0; i < length; i++) {
            arr.push([]);
            for (let j = 0; j < csvFmt.length; j++) {
                if (csvFmt[j] && csvFmt[j][i]) arr[i].push(csvFmt[j][i]);
                else arr[i].push(0);
            }
        }

        downloadCSVData(arr, this.props.widget.name);

        //  downloadCSVData(csvFmt, this.props.widget.name);
    };

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    }

    nodata = () => {
        let isDataPresent = false;
        Object.values(this.props.data.agg.tot).map((i) => {
            if (i !== 0) isDataPresent = true;
        });
        Object.values(this.props.data.agg.avg).map((i) => {
            if (i !== 0) isDataPresent = true;
        });

        return !(
            (this.props.data.agg && Object.keys(this.props.data.agg.avg).length && isDataPresent) ||
            (Object.keys(this.props.data.agg.tot).length && this.props.data.timeseries && this.props.data.timeseries.xs.length && isDataPresent)
        );
    };

    render() {
        let showLegend = this.props.hideLegendPie;
        let nodata = !this.props.data || this.nodata() || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info="Represents the estimated reach for posts and news for the duration and topics selected as per the filters."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!nodata ? (
                            <div className="chart-type">
                                <span onClick={() => this.props.changeGraphType("pie")} className={this.props.graph_type === "pie" ? "active-chart" : ""}>
                                    <Popup
                                        className="changeTypePopup"
                                        position="bottom right"
                                        size="tiny"
                                        wide="very"
                                        content="Pie Chart"
                                        trigger={<Icon name="pie chart" />}
                                    />
                                </span>
                                <span onClick={() => this.props.changeGraphType("bar")} className={this.props.graph_type === "bar" ? "active-chart" : ""}>
                                    <Popup
                                        className="changeTypePopup"
                                        position="bottom right"
                                        size="tiny"
                                        wide="very"
                                        content="Bar Chart"
                                        trigger={<Icon name="bar chart" />}
                                    />
                                </span>

                                <span onClick={() => this.props.changeGraphType("line")} className={this.props.graph_type === "line" ? "active-chart" : ""}>
                                    <Popup
                                        className="changeTypePopup"
                                        position="bottom right"
                                        size="tiny"
                                        wide="very"
                                        content="Line Chart"
                                        trigger={<Icon name="line chart" />}
                                    />
                                </span>
                            </div>
                        ) : null}
                        {!this.props.isResearchDashboard &&
                            this.props.graph_type !== "pie" &&
                            this.props.graph_type !== "bar" &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <Popup
                                    content="Chart Comparison Filters"
                                    position="bottom center"
                                    size="tiny"
                                    inverted
                                    className="skiptranslate"
                                    trigger={
                                        <div className={`chart-header-icon`} onClick={() => (!this.props.isPublic ? this.props.chartComparision() : null)}>
                                            <ComparisionIcon className={`comparision-filter${this.props.chartComparisionFilterApplied ? "-applied" : ""}`} />
                                        </div>
                                    }
                                />
                            )}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && <>{this.renderDownloadButton(nodata)}</>}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && this.props.graph_type !== "line" ? (
                            <CustomCheckBox checked={this.props.showLabel} onClick={this.props.changeShowLabel} label="Show Labels" />
                        ) : null}
                        {!nodata ? <CustomCheckBox checked={showLegend} onClick={() => this.props.changeHideLegendPie()} label="Show Legends" /> : null}
                        {!nodata && this.props.graph_type !== "pie" ? (
                            <CustomCheckBox checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} label="Show Grid Lines" />
                        ) : null}
                        {!nodata && this.props.graph_type === "line" ? (
                            <IntervalSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleIntervalChange={this.props.handleIntervalChange}
                                disableComparisonInterval={this.props.disableComparisonInterval}
                            />
                        ) : null}
                        {!nodata ? (
                            <CustomDropdown
                                className="interval-selector"
                                name="Select Data Type"
                                onChange={(val) => this.setState({ isTotal: val })}
                                value={this.state.isTotal}
                                options={[
                                    { key: "Total", label: "Total", value: true },
                                    { key: "Average", label: "Average", value: false },
                                ]}
                            />
                        ) : null}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                    {/* // {this.props.graph_type !== "pie" && this.props.graph_type !== "bar" && ( */}
                                    {/* //     <div className="clone-chart menu-option" onClick={this.props.chartComparision}>
                                //         <span>Chart Comparision</span>
                                //         <CloneIcon />
                                //     </div>
                                // )} */}
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}

                {!nodata ? (
                    <div className="dashboard-chart skiptranslate" ref={this.chartEl}>
                        {this.props.graph_type === "pie" ? (
                            <PieChart
                                dataProp={this.props.data.agg}
                                splineType={this.state.isTotal ? "tot" : "avg"}
                                allPlatforms={this.props.allPlatforms}
                                // resizedCount={this.props.resizedCount}
                                showLabel={this.props.showLabel}
                                showLegendBar={this.props.hideLegendPie}
                                showLegend={this.props.showLegend}
                                widgetContainerRef={this.props.widgetContainerRef}
                                currentChartType={this.props.graph_type}
                            />
                        ) : this.props.graph_type === "bar" ? (
                            <BarChart
                                dataProp={this.props.data.agg}
                                splineType={this.state.isTotal ? "tot" : "avg"}
                                allPlatforms={this.props.allPlatforms}
                                // resizedCount={this.props.resizedCount}
                                showGridLines={this.props.showGridLines}
                                showLabel={this.props.showLabel}
                                showLegendBar={this.props.hideLegendPie}
                                showLegend={this.props.showLegend}
                                widgetContainerRef={this.props.widgetContainerRef}
                                currentChartType={this.props.graph_type}
                            />
                        ) : (
                            <TimeSeries
                                dataProp={this.props.data.timeseries}
                                allPlatforms={this.props.allPlatforms}
                                aggs_val={this.props.aggs_val}
                                showGridLines={this.props.showGridLines}
                                splineType={this.state.isTotal ? "totres" : "avgres"}
                                // resizedCount={this.props.resizedCount}
                                showLabel={this.props.showLabel}
                                showLegend={this.props.hideLegendPie}
                                comparisionData={this.props.comparisionData && this.props.comparisionData.timeseries}
                                widgetContainerRef={this.props.widgetContainerRef}
                                legendClick={this.props.legendClick}
                                expandWidget={this.props.expandWidget}
                                currentChartType={this.props.graph_type}
                            />
                        )}
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        // allPlatforms: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.platforms : [],
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

export default connect(mapStateToProps)(EstReach);
